import {equals, omit, pipe, prop, map} from "ramda";

import { getRenamedAd } from '../utils/renameAd';

const AnimeShow = anime => ({
  ...omit(['content'], anime),
  ...anime.content
})

const Author = data => {
  const ads = map(prop('content'), data.adv || {});
  
  const header_banner_panel = getRenamedAd('header-banner', 'header_banner_panel', ads);
  
  return {
    ...data.story,
    content: {
      ...data.story.content,
      anime_shows: data.story.content.anime_shows.map(id => {
        const anime = data.rels.find(pipe(prop('uuid'), equals(id)))

        return AnimeShow(anime)
      }),
      ads: {
        ...omit(['header-banner'], ads),
        header_banner_panel
      }
    }
  }
}

export {Author}
